module.exports = __webpack_public_path__ + "img/default-product.8ec97162.png";